import {Breadcrumb} from "react-bootstrap";
import {useContext} from "react";
import {BreadcrumbsContext} from "../context/BreadcrumbsContext";
import {useHistory} from "react-router-dom";

export default function NsBreadcrumbs({
                                        handleClick = () => {},
                                      }) {

    const {elementiBreadcrumbs, goToElementoBreadcrumbs} = useContext(BreadcrumbsContext);

    const history = useHistory();

    return elementiBreadcrumbs && elementiBreadcrumbs.length > 0 && (
        <Breadcrumb>
            {
                elementiBreadcrumbs && elementiBreadcrumbs.map((elemento, index) => (
                    <Breadcrumb.Item
                        key={index}
                        active={index === elementiBreadcrumbs.length - 1}
                        onClick={() => {
                            goToElementoBreadcrumbs(elemento.name);

                            handleClick(elemento);

                            if (elemento.href && elemento.href !== '') {
                                history.push(elemento.href);
                            }
                        }}
                    >
                        {elemento.label}
                    </Breadcrumb.Item>
                ))
            }
        </Breadcrumb>
    );
}